import { useMantineTheme } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import React, { useState } from "react";

/**
 * Returns height based on the width of the device
 * @param xss
 * @param xs
 * @param sm
 * @param md
 * @param lg
 * @param xl
 * @returns height
 */
const ResponsiveHeight = (
  xxs: string,
  xs: string,
  sm: string,
  md: string,
  lg: string,
  xl: string
): string => {
  const [height, setHeight] = useState<string>("");
  const { width } = useViewportSize();
  const { breakpoints } = useMantineTheme();

  React.useEffect(() => {
    if (width < breakpoints.xs) setHeight(xxs);
    else if (width >= breakpoints.xs && width < breakpoints.sm) setHeight(xs);
    else if (width >= breakpoints.sm && width < breakpoints.md) setHeight(sm);
    else if (width >= breakpoints.md && width < breakpoints.lg) setHeight(md);
    else if (width >= breakpoints.lg && width < breakpoints.xl) setHeight(lg);
    else if (width >= breakpoints.xl) setHeight(xl);
  }, [width]);

  return height;
};
export default ResponsiveHeight;
